import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'tag/autocomplete/v2';

export function useTagAutocompleteV2Query({
	enabled,
	query,
	category,
	pageSize = 25,
	enforcePageSize,
	excludeHidden,
	impersonationContext,
}: {
	enabled?: boolean;
	query: string;
	category?: string;
	pageSize?: number;
	excludeHidden?: boolean;
	enforcePageSize?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery({
		enabled,
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.AccountTag>>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: BASE_QUERY_KEY,
					impersonationContext,
					queryParams: {
						query,
						category,
						pageSize,
						excludeHidden,
						enforcePageSize,
						pageToken: pageParam,
					},
				}),
				'GET'
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		queryKey: [
			BASE_QUERY_KEY,
			query,
			category,
			excludeHidden,
			pageSize,
			enforcePageSize,
			impersonationContext?.account?.id,
		],
		initialPageParam: '',
	});
}
